/**
 * 担当ボードの「今後のカバー予定」チップ用の純関数。将来日（今日より後）のカバーだけを日付 → 役割順に並べる。
 * @graph-stack product-innovation-lab
 * @graph-domain Operations
 * @graph-business 担当ボードのサービス行に出す「今後のカバー予定」を、将来日のみ・日付/役割順に整形する純関数
 * @graph-connects jstDateKey [calls] 基準日を JST 暦日キーへ整形して将来日を判定
 */
import { jstDateKey, type OpsCover } from '@cortex/ops-core';

/**
 * 将来日（`now` の JST 暦日より後）のカバーのみを日付 → 役割順で返す。今日・過去は除外し、無ければ空配列。
 * @graph-connects jstDateKey [calls] 今日の JST 暦日キーを算出して境界比較に使う
 */
export function upcomingCovers(covers: OpsCover[], now: Date): OpsCover[] {
  const todayKey = jstDateKey(now);
  return covers
    .filter((c) => c.date > todayKey)
    .sort((a, b) => a.date.localeCompare(b.date) || a.role.localeCompare(b.role));
}
